import { gql } from "@apollo/client"
import { InjectedOptions, useQuery } from "@oysterhr/core"
import { Query, QueryBenefitsEnrollmentArgs } from "@oysterhr/schema"

const BENEFITS_ENROLLMENT_CHANGE_HISTORY_QUERY = gql`
  query BenefitsStaffEnrollmentPriceHistory($enrollmentId: ID!) {
    benefitsEnrollment(enrollmentId: $enrollmentId) {
      id
      priceInvoicedCompany {
        currencyCode
      }
      engagement {
        isPayrollTeamMember
      }
      detailedHistory {
        changedField
        changedFrom
        changedTo
        changedAt
        userName
        whatdunnit
        effectiveDate
        holderName
        oysterStaff
      }
      authorizations {
        actions
      }
    }
  }
`

export function useEnrollmentChangeHistory(
  options: InjectedOptions<Pick<Query, "benefitsEnrollment">, QueryBenefitsEnrollmentArgs>,
) {
  return useQuery(BENEFITS_ENROLLMENT_CHANGE_HISTORY_QUERY, {
    fetchPolicy: "cache-and-network",
    ...options,
  })
}
